export default {
  mute: 'Mute',
  unmute: 'Unmute',
  hangup: 'Hang up',
  reject: 'Reject',
} as const;
